import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faBell,
    faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import "./TrancheLoanDashboard.css";
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import { useDispatch, useSelector } from 'react-redux';
import { getAllTranches } from '../../../redux/TrancheReducer/action';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import Sidebar from '../../../components/Sidebar/Sidebar';
import UserProfileDropdown from '../../../components/UserProfile/UserProfile';
import Tabs from '../../../components/Tab/Tabs';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';

const TrancheLoanDashboard = () => {
  const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('overview');

    const activeTrancheData = [
        {
            trancheId: "tranche-DEL-001",
            customerName: "Sushil Kumar",
            totalAmount: "54,000",
            installments: "4 / 6",
            outstandingAmount: "44,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            trancheDuration: "14/07- 20/10",
            supplierName: "Jai Kishan",
        },
        {
            trancheId: "tranche-DEL-002",
            customerName: "Anil Sharma",
            totalAmount: "34,000",
            installments: "2 / 6",
            outstandingAmount: "44,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            trancheDuration: "14/07- 20/10",
            supplierName: "Ravi Verma",
        },
        {
            trancheId: "tranche-DEL-003",
            customerName: "Vikram Singh",
            totalAmount: "48,000",
            installments: "3 / 6",
            outstandingAmount: "44,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            trancheDuration: "14/07- 20/10",
            supplierName: "Sneha Patel",
        },
        {
            trancheId: "tranche-DEL-004",
            customerName: "Priya Gupta",
            totalAmount: "18,000",
            installments: "4 / 6",
            outstandingAmount: "44,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            trancheDuration: "14/07- 20/10",
            supplierName: "Arjun Mehta",
        },
        {
            trancheId: "tranche-DEL-005",
            customerName: "Rahul Jain",
            totalAmount: "21,000",
            installments: "5 / 6",
            outstandingAmount: "44,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            trancheDuration: "14/07- 20/10",
            supplierName: "Kiran Desai",
        },
        {
            trancheId: "tranche-DEL-006",
            customerName: "Meena Kapoor",
            totalAmount: "44,000",
            installments: "4 / 6",
            outstandingAmount: "44,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            trancheDuration: "14/07- 20/10",
            supplierName: "Vikas Shah",
        },
    ];

    const pendingTrancheData = [
        {
            trancheId: "tranche-DEL-001",
            customerName: "Sushil Kumar",
            totalAmount: "54,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            dateRequested: "14/07- 20/10",
            installments: "4 / 6",
            supplierName: "Jai Kishan",
        },
        {
            trancheId: "tranche-DEL-002",
            customerName: "Anil Sharma",
            totalAmount: "34,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            dateRequested: "14/07- 20/10",
            installments: "2 / 6",
            supplierName: "Ravi Verma",
        },
        {
            trancheId: "tranche-DEL-003",
            customerName: "Vikram Singh",
            totalAmount: "48,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            dateRequested: "14/07- 20/10",
            installments: "3 / 6",
            supplierName: "Sneha Patel",
        },
        {
            trancheId: "tranche-DEL-004",
            customerName: "Priya Gupta",
            totalAmount: "18,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            dateRequested: "14/07- 20/10",
            installments: "4 / 6",
            supplierName: "Arjun Mehta",
        },
        {
            trancheId: "tranche-DEL-005",
            customerName: "Rahul Jain",
            totalAmount: "21,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            dateRequested: "14/07- 20/10",
            installments: "5 / 6",
            supplierName: "Kiran Desai",
        },
        {
            trancheId: "tranche-DEL-006",
            customerName: "Meena Kapoor",
            totalAmount: "44,000",
            branchName: "branch 1",
            roName: "Mukesh Jangid",
            dateRequested: "14/07- 20/10",
            installments: "4 / 6",
            supplierName: "Vikas Shah",
        },
    ];

    const trancheTabStatusMapping = {
        'overview': '',
        'active': '',
        'pending': 'pending',
        'past': 'closed'
    }

    const { tranches, pagination } = useSelector((store) => {
        return {
          tranches: store.TrancheReducer.tranches.data,
          pagination: store.TrancheReducer.tranches.pagination
        }
    }, []);


    const dispatch = useDispatch();

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('currentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('limit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('totalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    useEffect(() => {
        dispatch(getAllTranches(currentPage, limit, trancheTabStatusMapping[activeTab]));

        sessionStorage.setItem('currentPage', currentPage);
        sessionStorage.setItem('limit', limit);
    }, [dispatch, limit, currentPage, activeTab]);
    
    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('currentPage', pageToSet.toString());
    };

    // const renderContent = (tab) => {
    //     switch(tab){
    //         case 'overview': 
    //             return <OverviewTranche trancheData={tranches}/>
    //         case 'active':
    //             return <ActiveTranche trancheData={tranches}/>
    //         case 'pending':
    //             return <PendingTranche trancheData={tranches}/>
    //         case 'past':
    //             return <PastTranche trancheData={tranches}/>
    //         default:
    //             return <OverviewTranche trancheData={tranches}/>
    //     }
    // }

    return (
        <div className="trancheDashboardContainer">
            <div className="trancheDashboard">
                <Sidebar />

                <div className="dashboardMainContent">
                    <div className="contentHeader">
                        <div className="userLogo">
                            <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                        </div>
                        <div className="headerRightPanel">
                            <div className="headerSearchBar">
                                <input type="text" placeholder="Search" />
                                <FontAwesomeIcon icon={faSearch} />
                            </div>
                            <div className="headerNotifications">
                                <FontAwesomeIcon icon={faBell} />
                                <span className="notificationBadge">9+</span>
                            </div>
                            <div className="headerHelp">
                                <FontAwesomeIcon icon={faQuestionCircle} />
                            </div>
                            <UserProfileDropdown />
                        </div>
                    </div>
                    <div className="pageContentWrapper">
                        <div className="pageHeaderSection">
                            <div className="pageBreadcrumbs">
                                <Breadcrumb items={[
                                    { label: 'Tranches', onClick: () => navigate('/tranche-view') },
                                    { label: 'Profile' }
                                ]} />
                            </div>

                            <Tabs
                                component={"Tranche"}
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                            />
                        </div>


                        {/* <main className="tranche-table">
                            {renderContent(activeTab)}
                        </main> */}

                        {
                            (tranches?.length > 0) &&
                            <div className="paginationControls">
                                <CustomPagination 
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TrancheLoanDashboard